import { Checkbox, Select } from "@mantine/core";
import { useEffect, useState } from "react";
import VariableNumberInput from "../../../GlobalComponent/VariableNumberInput";
import VariableSelectCreate from "../../../GlobalComponent/VariableSelectCreate";
import VariableSelectWrite from "../../../GlobalComponent/VariableSelectWrite";

const SCOPE_LIST = [
    {
        label: "Mail.Read",
        value: "Mail.Read"
    },
    {
        label: "Mail.Read.All",
        value: "Mail.Read.All"
    }
]

const defaultState = {
    client_id: '',
    scope: SCOPE_LIST[0].value,
    refresh_token: '',
    grant_type: 'refresh_token',
    mailBox: 'INBOX',
    markMailAsRead: true,
    getLatestMail: true,
    subjectFilter: '',
    contentRegex: '',
    timeout: 30000,
    outputVariable: "",
    contentMailContains: '',
}

function ReadMailOauth2(props) {
    const [dataState, setDataState] = useState(props?.nodeData?.data?.options ?? defaultState)
    const onCheckBox = (key) => (e) => {
        setDataState({ ...dataState, [key]: e.target.checked })
    }

    const onChangeValue = (key, target) => e => {
        if (e?.type === 'change') {
            setDataState((state) => ({ ...state, [key]: target ? e.target[target] : e.target.value }))
        } else if (e?.type === 'click') {
            const newValue = e.newValue || ""
            setDataState((state) => ({ ...state, [key]: newValue }))
        } else {
            setDataState((state) => ({ ...state, [key]: e }))
        }
    }

    useEffect(() => {
        props.handleSetDataBaseModal({ ...dataState })
        console.log(dataState)
    }, [props, dataState])

    return (
        <>
            {
                <>
                        <VariableSelectWrite
                            placeholder="Your Client ID from Azure App Registration"
                            label="Client ID"
                            dataState={dataState.client_id}
                            handleData={onChangeValue('client_id')}
                            handleSelect={onChangeValue('client_id')}
                        />
                        <VariableSelectWrite
                            placeholder="Your refresh token from OAuth2 flow"
                            label="Refresh Token"
                            dataState={dataState.refresh_token}
                            handleData={onChangeValue('refresh_token')}
                            handleSelect={onChangeValue('refresh_token')}
                        />
                        <p style={{ fontSize: '12px'}}>Note: When the refresh token is expired, you need to get a new refresh token.</p>
                </>
            }
            {/* <VariableSelectWrite
                placeholder="INBOX"
                label="Mailbox"
                dataState={dataState.mailBox}
                handleData={onChangeValue('mailBox')}
                handleSelect={onChangeValue('mailBox')}
            /> */}

            <div style={{ marginTop: '20px' }}>
                <Checkbox
                    checked={dataState.markMailAsRead}
                    label="Mark mail as read"
                    onChange={onCheckBox('markMailAsRead')}
                />
                <Checkbox
                    checked={dataState.getLatestMail}
                    label="Get latest mail"
                    onChange={onCheckBox('getLatestMail')}
                />
            </div>
            {
                !dataState.getLatestMail && (
                    <VariableSelectWrite
                        placeholder="Subject"
                        label="Subject email contains"
                        dataState={dataState.subjectFilter}
                        handleData={onChangeValue('subjectFilter')}
                        handleSelect={onChangeValue('subjectFilter')}
                    />
                )
            }
            <VariableSelectWrite
                placeholder="Regex"
                label="Content mail contains"
                dataState={dataState.contentMailContains}
                handleData={onChangeValue('contentMailContains')}
                handleSelect={onChangeValue('contentMailContains')}
            />
            <VariableNumberInput
                label="Read mail timeout (milliseconds)"
                dataState={dataState.timeout}
                handleData={onChangeValue("timeout")}
                isMillisecond={true}
            />
            <VariableSelectCreate
                label="Output variable"
                placeholder="Select variable"
                value={dataState.outputVariable}
                handleChange={onChangeValue("outputVariable")}
            />
        </>
    );
}


export default ReadMailOauth2;